// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TbHS","col":"styles_col__2wr1r"};